document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-media-modal__content').forEach(function (content) {
    var dialogEl = content.parentElement;
    var closeBtn = dialogEl ? dialogEl.querySelector('.product-media-modal__toggle') : null;

    content.addEventListener('click', function (e) {
      if (e.target === content && closeBtn) {
        closeBtn.click();
      }
    });
  });
});